import styleConstants from 'assets/styles/style-constants';
import React from 'react';
var Header = function (_a) {
    var currentStep = _a.currentStep, steps = _a.steps;
    return (React.createElement("div", { style: { display: 'flex', columnGap: 16 } }, steps.map(function (step, index) { return (React.createElement("div", { key: index, style: {
            borderRadius: 4,
            height: 10,
            width: "".concat(100 / steps.length, "%"),
            background: index > currentStep ? styleConstants.colors.whiteSmoke : styleConstants.colors.primary.DEFAULT,
        } })); })));
};
export default Header;
